import * as React from "react";

import connectToList from "../../store/list";

import GenCheckboxFilter from "../Gen/CheckboxFilter";
import GenControlsBar from "../Gen/ControlsBar";
import GenMore from "../Gen/More";
import GenSearchBox from "../Gen/SearchBox";
import GenSortButtons from "../Gen/SortButtons";

import DocumentSetSummary from "../DocumentSet/Summary";

interface DocumentSetListProps {
  currentRoleDefinition: RoleDefinitionSnakeModel;
  documentSets: ConnectedList<DocumentSetSnakeModel>;
  showsOwnershipCheckbox: boolean;
  userId: number;
}

function DocumentSetList(props: DocumentSetListProps) {
  const {
    currentRoleDefinition,
    documentSets,
    showsOwnershipCheckbox,
    userId,
  } = props;

  React.useEffect(() => {
    documentSets.mountList("/document_sets");
  }, []);

  return (
    <div>
      <GenControlsBar>
        <GenSearchBox
          {...documentSets}
        />
        {showsOwnershipCheckbox && (
          <GenCheckboxFilter
            {...documentSets}
            filterKey="owner"
            option={["=", "document_sets.owner_id", userId]}
            label="Only courses that I own"
          />
        )}
        <div className="grow"/>
        <GenSortButtons
          {...documentSets}
          sortOptions={[
            {
              "title": "Name",
              "value": "document_sets.name",
            },
            {
              "title": "Owner",
              "value": "users.last_name",
            },
          ]}
        />
      </GenControlsBar>
      {
        documentSets.listData?.map((documentSet) => <DocumentSetSummary documentSet={documentSet} key={documentSet.id}/>)
      }
      <GenMore
        {...documentSets}
        shouldInfiniteScroll
        noItemsMessage={currentRoleDefinition?.name === "Learner" ? "You have not been added to any courses yet. If you believe this is a mistake, please contact your instructor." : undefined}
      />
    </div>
  );
}

export default connectToList(DocumentSetList, ["documentSets"]);
